/**
 * DEV-only Performance-Helfer (performance.mark/measure, keine UI-Strings).
 * Nutzung nur wenn import.meta.env.DEV und performance API vorhanden.
 */

export function devPerfEnabled() {
  try {
    return typeof import.meta !== "undefined" && !!import.meta.env?.DEV;
  } catch (_) {
    return false;
  }
}

export function devMark(name) {
  if (!devPerfEnabled() || typeof performance === "undefined" || typeof performance.mark !== "function") return;
  try {
    performance.mark(name);
  } catch (_) {}
}

/**
 * @param {string} measureName
 * @param {string} startMark
 * @param {string} endMark
 * @returns {PerformanceMeasure | null}
 */
export function devMeasure(measureName, startMark, endMark) {
  if (!devPerfEnabled() || typeof performance === "undefined" || typeof performance.measure !== "function") {
    return null;
  }
  try {
    return performance.measure(measureName, startMark, endMark);
  } catch (_) {
    try {
      return performance.measure(measureName, { start: startMark, end: endMark });
    } catch (_) {
      return null;
    }
  }
}

export async function devTimeAsync(label, fn) {
  if (!devPerfEnabled()) return fn();
  const a = `${label}:start`;
  const b = `${label}:end`;
  devMark(a);
  try {
    const out = await fn();
    devMark(b);
    const m = devMeasure(label, a, b);
    if (m && typeof console !== "undefined" && console.debug) {
      console.debug(`[perf] ${label}`, { durationMs: Math.round(m.duration * 10) / 10 });
    }
    return out;
  } catch (e) {
    devMark(b);
    throw e;
  }
}
